import React from 'react';

export default function SVGCopy(): JSX.Element {
  return (
    <svg
      width="19"
      height="23"
      viewBox="0 0 19 23"
      fill="none"
      className="text-iconStrong fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 0.0935059H2C0.9 0.0935059 0 0.993506 0 2.09351V16.0935H2V2.09351H14V0.0935059ZM17 4.09351H6C4.9 4.09351 4 4.99351 4 6.09351V20.0935C4 21.1935 4.9 22.0935 6 22.0935H17C18.1 22.0935 19 21.1935 19 20.0935V6.09351C19 4.99351 18.1 4.09351 17 4.09351ZM17 20.0935H6V6.09351H17V20.0935Z" />
    </svg>
  );
}
